import { MEMBERS_APP_ID, SANTA_MEMBERS_APP_ID } from '../constants/applications';
import { getApplicationConfig } from '../selectors/communities-context-selectors';

export const isMemberPartInstalled = state => (
  getApplicationConfig(state, MEMBERS_APP_ID).isInstalled ||
  getApplicationConfig(state, SANTA_MEMBERS_APP_ID).isInstalled
);



// WEBPACK FOOTER //
// ./app/selectors/is-member-part-installed.js